function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import regeneratorRuntime from "regenerator-runtime";
import { defineComponent, ref, reactive, onMounted } from "vue";
import SearchBar from "@/components/SearchV3/index.vue";
import TableList from "@/components/TableList/index.vue";
import Pagination from "@/components/Pagination/index.vue";
import searchMixin from "@/mixin/search";
import { getPaymentOrderList } from "@pt/api/payment";
import { paymentRecordStatusOptions, paymentRecordStatusConfig, transactionStatusConfig, grantOrderTypeOptions, grantOrderTypeConfig } from "@pt/views/account-management/payment-record/config";
import { currencyOptions } from "@/common/permission";
import { fmtTime, fmtThousands } from "@com/utils/data-format";
import _ from "lodash";
var defaultschema = {
    adv_ids: "",
    date: "",
    order: "",
    page: 1,
    page_size: 15,
    status: "",
    c_date: "",
    types: ""
};
export default defineComponent({
    components: {
        SearchBar: SearchBar,
        TableList: TableList,
        Pagination: Pagination
    },
    mixins: [
        searchMixin
    ],
    setup: function setup() {
        var listLoading = ref(false);
        var pagination = reactive({
            total: 3
        });
        var schema = [
            {
                label: "\u5E7F\u544A\u4E3B:",
                prop: "adv_ids",
                type: "business",
                subtype: "advertiser-selector",
                params: {
                    multiple: true,
                    filterable: true,
                    collapseTags: true,
                    style: "width: 220px;",
                    class: "search-filter-select"
                }
            },
            {
                label: "\u8BA2\u5355\u7C7B\u578B:",
                prop: "types",
                type: "select",
                params: {
                    multiple: true,
                    placeholder: "\u8BA2\u5355\u7C7B\u578B",
                    options: grantOrderTypeOptions,
                    clearable: true
                }
            },
            {
                label: "\u8BA2\u5355\u72B6\u6001:",
                prop: "status",
                type: "select",
                params: {
                    multiple: true,
                    placeholder: "\u8BA2\u5355\u72B6\u6001",
                    options: paymentRecordStatusOptions,
                    clearable: true
                }
            },
            {
                label: "\u521B\u5EFA\u65F6\u95F4:",
                prop: "c_date",
                type: "date-picker",
                subtype: "daterange",
                class: "date-picker",
                params: {
                    format: "yyyy-MM-dd",
                    valueFormat: "yyyy-MM-dd",
                    pickerOptions: {}
                }
            },
            {
                label: "\u8BA2\u5355\u5B8C\u6210\u65F6\u95F4:",
                prop: "date",
                type: "date-picker",
                subtype: "daterange",
                params: {
                    format: "yyyy-MM-dd",
                    valueFormat: "yyyy-MM-dd",
                    pickerOptions: {}
                }
            }, 
        ];
        var query = ref(defaultschema);
        var formConfig = {
            inline: true,
            labelPosition: "left",
            labelWidth: ""
        };
        var list = ref([]);
        var tableColumnConfig = [
            {
                label: "\u8BA2\u5355\u53F7",
                prop: "id",
                width: "100px"
            },
            {
                label: "\u8BA2\u5355\u521B\u5EFA\u65F6\u95F4",
                prop: "create_time",
                width: "100px",
                params: {
                    innerHTML: function(param) {
                        var row = param.row;
                        return fmtTime(row.created_time);
                    }
                }
            },
            {
                label: "PT\u8D26\u6237\u540D",
                prop: "adv_name"
            },
            {
                label: "3S username",
                prop: "username_3s",
                width: "100px"
            },
            {
                label: "\u5BA2\u6237\u4E3B\u4F53\u540D\u79F0",
                prop: "partner_name",
                width: "100px"
            },
            {
                label: "\u5BA2\u6237\u56FD\u5BB6",
                prop: "partner_country_code"
            },
            {
                label: "\u6211\u65B9\u4E3B\u4F53\u540D\u79F0",
                prop: "receive_company_name",
                width: "100px"
            },
            {
                label: "\u5E01\u79CD",
                prop: "currency",
                params: {
                    innerHTML: function(param) {
                        var row = param.row;
                        return currencyOptions[row.currency] || "-";
                    }
                }
            },
            {
                label: "\u4EA4\u6613\u7C7B\u578B",
                prop: "type",
                params: {
                    innerHTML: function(param) {
                        var row = param.row;
                        var _$ref;
                        return ((_$ref = grantOrderTypeConfig[row.type]) === null || _$ref === void 0 ? void 0 : _$ref.label) || "";
                    }
                }
            },
            {
                label: "\u4EA4\u6613\u91D1\u989D",
                prop: "amount",
                sortable: true,
                params: {
                    innerHTML: function(param) {
                        var row = param.row;
                        return row.amount ? fmtThousands(row.amount) : "-";
                    }
                },
                width: "100px"
            },
            {
                label: "\u4EA4\u6613ID",
                prop: "transaction_id"
            },
            {
                label: "\u4EA4\u6613\u72B6\u6001",
                prop: "transaction_status",
                params: {
                    innerHTML: function(param) {
                        var row = param.row;
                        var _$ref;
                        return ((_$ref = transactionStatusConfig[row.transaction_status]) === null || _$ref === void 0 ? void 0 : _$ref.label) || "";
                    }
                }
            },
            {
                label: "\u652F\u4ED8\u65B9\u5F0F",
                prop: "payment_type"
            },
            {
                label: "\u4EA4\u6613\u5B8C\u6210\u65F6\u95F4",
                prop: "completed_time",
                width: "100px",
                params: {
                    innerHTML: function(param) {
                        var row = param.row;
                        return fmtTime(row.completed_time);
                    }
                }
            },
            {
                label: "\u8BA2\u5355\u72B6\u6001",
                prop: "status",
                params: {
                    innerHTML: function(param) {
                        var row = param.row;
                        var _$ref;
                        return ((_$ref = paymentRecordStatusConfig[row.status]) === null || _$ref === void 0 ? void 0 : _$ref.label) || "";
                    }
                }
            },
            {
                label: "\u8BA2\u5355\u5B8C\u6210\u65F6\u95F4",
                prop: "updated_time",
                width: "140px",
                params: {
                    innerHTML: function(param) {
                        var row = param.row;
                        return fmtTime(row.updated_time);
                    }
                },
                sortable: true
            },
            {
                label: "\u5408\u540C\u7F16\u7801",
                prop: "contract_code"
            }, 
        ];
        var handleParams = function() {
            var newParams = _.cloneDeep(query.value);
            if (query.value.date && query.value.date.length > 0) {
                newParams.start_date = query.value.date[0];
                newParams.end_date = query.value.date[1];
            }
            if (query.value.c_date && query.value.c_date.length > 0) {
                newParams.c_start_date = query.value.c_date[0];
                newParams.c_end_date = query.value.c_date[1];
            }
            newParams = _.omit(newParams, [
                "c_date",
                "date", 
            ]);
            return newParams;
        };
        var getRenderList = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                var res;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return getPaymentOrderList(handleParams());
                        case 2:
                            res = _ctx.sent;
                            list.value = res.data.data.list ? res.data.data.list : [];
                            pagination.total = res.data.data.total;
                        case 5:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function getRenderList() {
                return _ref.apply(this, arguments);
            };
        }();
        var handleSortChange = function(param) {
            var prop = param.prop, order = param.order;
            if (order) {
                query.value.order = order === "ascending" ? prop : "-".concat(prop);
            } else {
                query.value.order = "";
            }
            getRenderList();
        };
        onMounted(function() {
            getRenderList();
        });
        return {
            listLoading: listLoading,
            schema: schema,
            query: query,
            formConfig: formConfig,
            tableColumnConfig: tableColumnConfig,
            list: list,
            pagination: pagination,
            getRenderList: getRenderList,
            handleSortChange: handleSortChange
        };
    },
    watch: {
        $route: function $route(to, from) {
            if (_.isEmpty(to.query)) {
                this.query = _objectSpread({}, defaultschema);
            }
            this.getRenderList();
        }
    }
});
